export interface PendingCycleResetSubscriptionLike {
  /** Backend: an early PIX renewal keeps the current limits until this instant. */
  pending_cycle_reset_at?: string | null;
}

/**
 * When the renewed cycle of a PIX renewal paid early starts, while that moment
 * is still ahead: until then the current limits keep running and the customer
 * may start the new cycle now (`startRenewedCycleNow`). Null otherwise.
 */
export function pendingCycleResetAt(
  subscription: PendingCycleResetSubscriptionLike | null | undefined,
  now: Date,
): Date | null {
  const value = subscription?.pending_cycle_reset_at;
  if (!value) return null;
  const at = new Date(value);
  const time = at.getTime();
  return !Number.isNaN(time) && time > now.getTime() ? at : null;
}
